import React from 'react';
import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../../constant';
import { DeleteItemButton } from '../configMeta';

const FormBuilder = ({ items, setItems, onSubmit, history, onDeleteSavedItem }) => {
    const onItemLabelChange = (index, value) => {
        const updated = [...items];
        updated[index].label = value;
        setItems(updated);
    };

    const onAddItem = () => {
        const updated = [...items, { id: '', label: '', active: true }];
        setItems(updated);
    };

    const onToggleItemActive = (index) => {
        const updated = [...items];
        const item = updated[index];

        if (item.id) {
            item.active = !item.active;
        } else {
            if (item.active === false) {
                item.active = true;
            } else {
                updated.splice(index, 1);
            }
        }
        setItems(updated);
    };

    // Hard delete: drop the row and, if it was saved, ask the page to send its id
    // in deletedIds. The API deactivates ids that submissions still reference.
    const onRemoveItem = (index) => {
        const updated = [...items];
        const [removed] = updated.splice(index, 1);
        if (removed?.id && onDeleteSavedItem) onDeleteSavedItem(removed.id);
        setItems(updated);
    };

    return (
        <div>
            <div className="appraisal-report-table-responsive">
                <table className="assessment-table" cellSpacing={0}>
                    <thead>
                        <tr>
                            <td className="hd-s2 pd10 w100">S.No.</td>
                            <td className="hd-s1 pd10">ITEM DESCRIPTION</td>
                            {/* <td className="hd-s2 w200 pd10">REFERENCE DOCUMENT</td>
                            <td className="hd-s2 w200 pd10">REMARKS</td>
                            <td className="hd-s2 pd10" colSpan={2}>STATUS OF COMPLETION</td> */}
                            <td className="hd-s2 pd10">ACTION</td>
                        </tr>
                        {/* <tr>
                            <td className="td-s1" />
                            <td className="td-s2" />
                            <td className="td-s2" />
                            <td />
                            <td className="check-td-s3 text-center">Yes</td>
                            <td className="check-td-s3 text-center">No</td>
                            <td />
                        </tr> */}
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={item.id || index}>
                                <td className="td-s1">
                                    <p className="s1">{index + 1}.</p>
                                </td>
                                <td className="td-s2 tb-input-value">
                                    <textarea
                                        rows={1}
                                        className="form-control"
                                        placeholder="Enter Item Description"
                                        value={item.label}
                                        onChange={(e) => onItemLabelChange(index, e.target.value)}
                                        disabled={item.active === false}
                                    />
                                </td>
                                {/* <td />
                                <td />

                                <td className="td-form-check text-center">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name={`status-${index}`}
                                        value="yes"
                                        disabled={item.active === false}
                                    />
                                </td>
                                <td className="td-form-check text-center">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name={`status-${index}`}
                                        value="no"
                                        disabled={item.active === false}
                                    />
                                </td> */}
                                <td className="td-form-check text-center">
                                    <button
                                        type="button"
                                        className={`btn btn-sm ${item.active === false ? 'btn-success' : 'btn-outline-danger'}`}
                                        onClick={() => onToggleItemActive(index)}
                                        title={item.active === false ? 'Show this item on the form again' : 'Hide from new forms, keep on past submissions'}
                                    >
                                        {item.active === false ? 'Activate' : 'Deactivate'}
                                    </button>
                                    <DeleteItemButton onClick={() => onRemoveItem(index)} />
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={7} className="text-center">
                                <button type="button" className="btn btn-link" onClick={onAddItem}>
                                    + Add New Item
                                </button>
                                {/* <button type="button" className="btn btn-link add-new-item-btn" onClick={onAddItem}>
                                    + Add New Item
                                </button> */}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row mt-4">
                <div className="col-lg-12 text-left ">
                    <button
                        onClick={() => { onSubmit() }}
                        type='button'
                        className="btn btn-success"
                        style={{
                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                            borderColor: "#2b5a7e"
                        }}
                    >
                        Save
                    </button>
                    <button
                        type="reset"
                        className="btn btn-danger ms-3"
                        onClick={() => { history.push(constant.Authedcomponent.submittedNewBuildingFinalDeliveryDocumentChecksheet.url) }}
                        style={{
                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                            borderColor: "#2b5a7e"
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div >
    );
};

export default withRouter(FormBuilder);
